
import TopItemPicker from './scheduler/TopItemPickerV2.vue';
import CollapseItem from './scheduler/CollapseItem.vue';
import ItemLeftHeader from './scheduler/ItemLeftHeader.vue';
import CircleProgressHeader from './scheduler/CircleProgressHeader.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ItemRightHeader from './scheduler/ItemRightHeader.vue';
import ManagerCollapse from './scheduler/ManagerCollapse.vue';
import ContractorCollapse from './scheduler/ContractorCollapse.vue';
import ProjectCollapse from './scheduler/ProjectCollapse.vue';
import { BryntumScheduler } from '@bryntum/schedulerpro-vue';
import CollapsedFilled from '@/components/icons/CollapseFilled.vue';
import ExpandFilled from '@/components/icons/ExpandFilled.vue';

import TimelineOptionsWithTemplates from '@/entities/scheduler/TimelineOptionsWithTemplates';
import { User } from '@/generated/graphql';

import { schedulerConfig } from './SchedularConfig';

@Component({
	components: {
		TopItemPicker,
		ItemLeftHeader,
		CircleProgressHeader,
		ItemRightHeader,
		CollapseItem,
		ManagerCollapse,
		ContractorCollapse,
		ProjectCollapse,
		BryntumScheduler,
		CollapsedFilled,
		ExpandFilled,
	},
})
export default class Scheduler extends Vue {
	//create filterBy prop
	@Prop({ default: 'Manager' }) filterBy!: string;

	@Prop({ type: Array, default: () => { } }) resources!: any[];
	@Prop({ type: Array, default: () => [] }) events!: any[];
	@Prop({ type: Object, default: () => { } }) readonly listeners!: Object;
	@Prop({ type: String, default: 'Clients' }) readonly schedularType: String;

	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: String, default: null }) readonly companyId!: string;
	@Prop({ type: Array, default: () => [] }) readonly itemsSelection!: any[];
	@Prop({ type: Object, default: () => ({}) })
	readonly customOptions!: TimelineOptionsWithTemplates;
	@Prop({ type: String, default: '' }) readonly schedulerView!: string;
	intervalId = null;
	storageInveralId = null;
	//current date
	// currentDate = schedulerConfig.startDate;
	// endDate = schedulerConfig.endDate;
	isCollapsed: boolean = false;
	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	//getmonth name
	get getSchedulerConfig() {
		const config = {
			...schedulerConfig,
			resources: this.resources.map(r => {
				const newr = { ...r };
				if (newr.name) {
					newr.name = this.capitalizeFirstLetter(newr.name)
				}
				if (newr.title) {
					newr.title = this.capitalizeFirstLetter(newr.title)
				}
				return newr
			}),
			events: this.events,
			listeners: this.listeners,
		};
		return config;
	}
	today() {
		const schedulerElement = this.$refs.scheduler as any;
		const schedulerInstance = schedulerElement.instance;
		// Scrolls the scheduler to the current date
		if (schedulerInstance) {
			schedulerInstance.scrollToDate(new Date(), {
				block: "center", // centers the date
				animate: false, // animates the scrolling
			});
		}
	}
	setDate() {
		this.clearIntervals()
		const doc = (document.getElementById("b-mask-1") || document.getElementsByClassName('b-mask')?.[0]) as HTMLDivElement
		if (doc) {
			doc.remove()
		}
		localStorage.setItem('b-schedulerpro-trial-start', new Date().getTime() + '');
	}
	clearIntervals() {

		window.clearInterval(this.storageInveralId)
		window.clearInterval(this.intervalId)
	}
	beforeMount() {
		this.setDate();
		this.intervalId = window.setInterval(() => {
			const doc = (document.getElementById("b-mask-1") || document.getElementsByClassName('b-mask')?.[0]) as HTMLDivElement
			if (doc) {
				localStorage.setItem('b-schedulerpro-trial-start', new Date().getTime() + '');
				doc.remove()
			} else {
				const doc = (document.getElementById("b-mask-2") || document.getElementById("b-mask-3")) as HTMLDivElement
				if (doc) {
					localStorage.setItem('b-schedulerpro-trial-start', new Date().getTime() + '');
					doc.remove()
				}
			}
		}, 100)
	}
	unmounted() {
		this.clearIntervals()
	}
	mounted() {

		setTimeout(() => {
			this.today();
		}, 10);
	}
	collapseAll() {
		this.resources = this.resources.map((resource: any) => {
			return { ...resource, expanded: !this.isCollapsed };
		});
		this.isCollapsed = !this.isCollapsed;
	}
}
